import { render } from "./Product.vue?vue&type=template&id=7101bd94&scoped=true&ts=true"
import script from "./Product.vue?vue&type=script&lang=ts"
export * from "./Product.vue?vue&type=script&lang=ts"

import "./Product.vue?vue&type=style&index=0&id=7101bd94&scoped=true&lang=scss"

import exportComponent from "G:\\Runze\\rzhy_main_web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7101bd94"]])

export default __exports__